<h2 mat-dialog-title>
    <mat-icon>summarize</mat-icon>
    <span>{{'SummaryPromptConfiguration' | translate}}</span>
</h2>

<mat-dialog-content>
    <p class="dialog-description">
        {{'SummaryPromptDescription' | translate}}
    </p>

    <form [formGroup]="summaryForm">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{'Name' | translate}}</mat-label>
            <input matInput formControlName="name" [placeholder]="'SummaryPromptNamePlaceholder' | translate">
            @if (summaryForm.get('name')?.hasError('required')) {
                <mat-error>{{'FieldRequired' | translate}}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{'Context' | translate}}</mat-label>
            <textarea 
                matInput 
                formControlName="context" 
                rows="3"
                [placeholder]="'SummaryContextPlaceholder' | translate">
            </textarea>
            @if (summaryForm.get('context')?.hasError('required')) {
                <mat-error>{{'FieldRequired' | translate}}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{'PromptContent' | translate}}</mat-label>
            <textarea 
                matInput 
                formControlName="content" 
                rows="6"
                [placeholder]="'SummaryContentPlaceholder' | translate">
            </textarea>
            @if (summaryForm.get('content')?.hasError('required')) {
                <mat-error>{{'FieldRequired' | translate}}</mat-error>
            }
        </mat-form-field>

        <div class="field-selection-section">
            <h3 class="section-title">
                <mat-icon>checklist</mat-icon>
                <span>{{'SelectInputFields' | translate}}</span>
            </h3>
            <p class="section-description">
                {{'SelectInputFieldsDescription' | translate}} <strong>Order matters</strong> - drag to reorder selected fields for summary construction.
            </p>

            @if (availableFields.length === 0) {
                <div class="no-fields-message">
                    <mat-icon>warning</mat-icon>
                    <p>{{'NoOutputSchemaFieldsMessage' | translate}}</p>
                </div>
            } @else {
                <div 
                    formArrayName="selectedFields" 
                    class="fields-list"
                    cdkDropList
                    (cdkDropListDropped)="onFieldDrop($event)">
                    @for (field of availableFields; track field.field_name; let i = $index) {
                        <div class="field-item" cdkDrag>
                            <div class="drag-handle" cdkDragHandle>
                                <mat-icon>drag_indicator</mat-icon>
                            </div>
                            <mat-checkbox [formControlName]="i" class="field-checkbox">
                                <span class="field-name">{{ field.field_name }}</span>
                                <span class="field-type">({{ field.field_type }})</span>
                            </mat-checkbox>
                        </div>
                    }
                </div>
                @if (summaryForm.get('selectedFields')?.hasError('noSelection')) {
                    <div class="error-message">
                        <mat-icon>error</mat-icon>
                        <span>{{'AtLeastOneFieldRequired' | translate}}</span>
                    </div>
                }
            }
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    @if (hasExistingSummaryPrompt) {
    <button
        mat-stroked-button
        color="warn"
        type="button"
        [disabled]="isDeleting || isSubmitting"
        (click)="deleteSummaryPrompt()">
        <mat-icon>delete</mat-icon>
        @if (isDeleting) {
            <span>Deleting...</span>
        } @else {
            <span>Delete Summary Prompt</span>
        }
    </button>
    }
    <span class="spacer"></span>
    <button 
        mat-button 
        type="button"
        (click)="cancel()"
        [disabled]="isSubmitting || isDeleting">
        {{'Cancel' | translate}}
    </button>
    <button 
        mat-button 
        mat-flat-button 
        color="primary" 
        type="button"
        [disabled]="summaryForm.invalid || isSubmitting || isDeleting || availableFields.length === 0"
        (click)="saveSummaryPrompt()">
        @if (isSubmitting) {
            <ng-container>
                <span>{{'Saving' | translate}}...</span>
            </ng-container>
        } @else {
            <ng-container>
                <span>{{'SaveSummaryPrompt' | translate}}</span>
            </ng-container>
        }
    </button>
</mat-dialog-actions>
